import { nameConfiguration } from "./configurationProvider";

const nameConversion = (str) => {
  if (!str || !str.length) return str;

  if (nameConfiguration[str] !== undefined) {
    return nameConfiguration[str];
  } else {
    return str;
  }
};

export default nameConversion;
